<div [ngClass]="{ 'd-flex flex-direction-column justify-content-center align-items-center': message }">
  <ng-lottie [options]="type | getLoaderJsonPipe" width="{{ size }}px"></ng-lottie>
  <div *ngIf="message" class="message">{{ message }}</div>
</div>
